<template>
  <div class="form-textarea" :style="style">
    <span @click="inputClick" v-if="$store.state.assigningIndexes" class="tab-index" :style="tabOrderStyle">
      {{ ($store.getters.templateTabOrder(id) > -1) ? $store.getters.templateTabOrder(id) : '?' }}
    </span>
    <textarea
      @focus="focusInput"
      @blur="noFocus"
      @contextmenu="inputClick"
      @keyup="showAutocompleteModel"
      :tabindex="$store.getters.templateTabOrder(id)"
      :id="id"
      v-model="value"
      :data-model="model"
    ></textarea>
  </div>
</template>

<script>
  import mixinEditor from '@/mixins/editor.js'

  export default {
    name: 'form-textarea',

    data () {
      return {
        editMode: false
      }
    },

    mixins: [mixinEditor],

    props: [
      'id',
      'width',
      'height',
      'left',
      'top',
      'fontSize',
      'model'
    ],

    methods: {
      noFocus () {
        this.$bus.emit('scrollToElement', this.id)

        this.hideAutocomplete()
      },

      inputClick (e) {
        e.preventDefault()
        this.$bus.emit('openFieldMenu', {
          id: this.id,
          pos: { x: e.pageX, y: e.pageY },
          tabOrder: this.tabOrder
        })
      },

      focusInput () {
        const highlighted = document.querySelectorAll('.id-highlight')
        for (const highlight of highlighted) {
          highlight.classList.remove('id-highlight')
        }
        this.$bus.emit('scrollToElement', this.id)
      },

      showAutocompleteModel (e) {
        if (typeof e !== 'number') this.setAutocompleteModel()
      }
    },

    computed: {
      style () {
        let styleStr = 'position: absolute;'
        styleStr += 'width: ' + this.width + 'px;'
        styleStr += 'height: ' + this.height + 'px;'
        styleStr += 'left: ' + this.left + 'px;'
        styleStr += 'top: ' + this.top + 'px;'
        styleStr += 'font-size: ' + this.fontSize + 'px;'
        return styleStr
      },

      tabOrderStyle () {
        let tabStyleStr = ''
        tabStyleStr += 'width: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'height: ' + 20 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'font-size: ' + 14 * this.$store.state.pageScale + 'px;'
        tabStyleStr += 'left: -' + 22 * this.$store.state.pageScale + 'px;'
        return tabStyleStr
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab-index {
    user-select: none;
    position: absolute;
    top: 15%;
    min-width: 22px;
    min-height: 22px;
    background-color: #5E738B;
    border: 2px solid #333;
    color: #FFF;
    text-align: center;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      outline: 3px dashed blue;

      &+textarea {
        outline: 2px dashed blue !important;
      }
    }
  }

  textarea {
    width: 100%;
    height: 100%;
    z-index: 10;
    &:hover {
      outline: green 3px solid;
    }
    &:focus {
      outline: rgb(3, 216, 170) solid 3px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/inputs/FormTextarea.vue